<template>
  <ckeditor
    :editor="editor"
    :config="editorConfig"
    @ready="editorInit"
    :disabled="isReadOnly"
    v-bind="$attrs"
    v-on="$listeners"
  ></ckeditor>
</template>

<script>
import DecoupledDocument from '@ckeditor/ckeditor5-build-decoupled-document';
import Base64Upload from '@/plugins/ckeditor5/base64Upload/Base64Upload';
export default {
  props: {
    isReadOnly: {
      type: Boolean,
      default: false,
    },
    config: {
      type: Object,
      default: null,
    },
  },

  data() {
    return {
      editor: DecoupledDocument,
      editorConfig: { extraPlugins: [Base64Upload], ...this.config },
    };
  },
  methods: {
    editorInit(editor) {
      const toolbar = editor.ui.view.toolbar.element;
      editor.on('change:isReadOnly', (_, __, flag) => {
        toolbar.style.display = flag ? 'none' : '';
      });
      editor.ui
        .getEditableElement()
        .parentElement.insertBefore(toolbar, editor.ui.getEditableElement());
      toolbar.style.display = this.isReadOnly ? 'none' : '';
    },
  },
};
</script>

<style></style>
